import axios from "axios";

// Utilise la variable d'environnement définie (ex: REACT_APP_API_URL=http://localhost:5000)
// fallback sur http://localhost:5000 si non défini (dev local)
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

// Key used to store the jugeboxe student session token in sessionStorage
const JUGEBOXE_STUDENT_TOKEN_KEY = 'jugeboxeStudentToken';

const api = axios.create({
  baseURL: API_URL,
  timeout: 20000,
  headers: {
    "Content-Type": "application/json",
  },
});

const JUGEBOXE_STUDENT_AUTH_PATHS = [
  '/jugeboxe/eleves',
];

// Ajoute automatiquement le token à chaque requête si présent.
// Pour les routes /jugeboxe, utilise le token de session étudiant sauf si la requête
// force l'auth prof via { useTeacherAuth: true }.
api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  const url = config.url || '';
  const forceTeacherAuth = config.useTeacherAuth === true;
  const studentToken = sessionStorage.getItem(JUGEBOXE_STUDENT_TOKEN_KEY);

  const isStudentJugeboxeRequest =
    config.useStudentAuth === true ||
    JUGEBOXE_STUDENT_AUTH_PATHS.some((path) => url.startsWith(path));

  if (!forceTeacherAuth && studentToken && isStudentJugeboxeRequest) {
    config.headers.Authorization = 'Bearer ' + studentToken;
  } else {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = 'Bearer ' + token;
    }
  }

  return config;
}, (error) => Promise.reject(error));

export default api;
